export default "__VITE_ASSET__bGDewN14__"